"use client";

import { AlertTriangle } from "lucide-react";

interface ValidationMessageProps {
  message: string;
}

export default function ValidationMessage({ message }: ValidationMessageProps) {
  if (!message) return null;

  return (
    <div className="rounded-lg border border-amber-200 bg-amber-50 p-4 text-sm text-amber-800 dark:border-amber-800 dark:bg-amber-950 dark:text-amber-200">
      <div className="flex items-center gap-2">
        <AlertTriangle className="h-4 w-4" />
        <span>{message}</span>
      </div>
    </div>
  );
}
